import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatError, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { finalize } from 'rxjs';
import { GwcApiAdminUsersService } from '@src/app/services/gwc-api/admin-users.service';

@Component({
    selector: 'gwc-admin-change-password-dialog',
    templateUrl: './change-password-dialog.component.html',
    imports: [ReactiveFormsModule, MatButton, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle, MatError, MatFormField, MatInput]
})
export class ChangePasswordDialogComponent {
    isSaving = false;
    serverError = '';

    form = this._formBuilder.nonNullable.group({
        current_password: ['', Validators.required],
        password: ['', [Validators.required, Validators.minLength(12)]],
        password_confirmation: ['', Validators.required]
    });

    constructor(
        private _formBuilder: FormBuilder,
        private _api: GwcApiAdminUsersService,
        private _dialogRef: MatDialogRef<ChangePasswordDialogComponent>
    ) {}

    submit(): void {
        this.serverError = '';
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }
        if (this.form.value.password !== this.form.value.password_confirmation) {
            this.serverError = 'The new passwords do not match.';
            return;
        }

        this.isSaving = true;
        this._api.changePassword(this.form.getRawValue())
            .pipe(finalize(() => this.isSaving = false))
            .subscribe({
                next: () => this._dialogRef.close(true),
                error: error => this.serverError = error?.error?.message ?? 'The password could not be changed.'
            });
    }
}
